import { gql } from '@apollo/client'

import { UNKNOWN_WORD_LIST_FRAGMENT } from '../fragments'

const CONFIRM_UNKNOWN_WORD_MUTATION = gql`
  mutation confirmUnknownWordMutation(
    $id: ID!
    $data: UnknownWordUpdateInput!
  ) {
    confirmUnknownWord(id: $id, data: $data) {
      ...UnknownWordListFragment
    }
  }
  ${UNKNOWN_WORD_LIST_FRAGMENT}
`

export default CONFIRM_UNKNOWN_WORD_MUTATION
